export enum SupportTicketTypeEnum {
  ERROR = 'ERROR',
  IMPROVEMENT = 'IMPROVEMENT'
}
